// Static seat layout for the Dubai A6 Office.
// Seat assignments themselves (which user sits where) are stored server-side
// via the floor_plan_seats API - this file only describes the physical layout.
// Seat keys are prefixed with "da6" so they never collide with other floors.

import { seatBlock } from './seatLayout';

// Single centered column: top and bottom 2x2 blocks bookending a taller 3x2 block.
export const topGroup = seatBlock('da6', 1, 2, 2);
export const middleGroup = seatBlock('da6', 2, 3, 2);
export const bottomGroup = seatBlock('da6', 3, 2, 2);

// Roughly locates a seat key within the layout so unit bubbles can be placed
// on the rail of the Dubai A6 tab. All seats sit in a single centered column,
// so everything lives on the "left" rail.
export function parseDubaiA6SeatKey(seatKey) {
    const [prefix, group] = seatKey.split('-');
    const groupIndex = Number(group) || 0;
    return { side: 'left', groupIndex, groupKey: `${prefix}-${groupIndex}` };
}

export const allDubaiA6Seats = [
    ...topGroup.flat(),
    ...middleGroup.flat(),
    ...bottomGroup.flat(),
];
